import { createApp } from 'vue';
import '@lottiefiles/dotlottie-vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import api from '@/utils/axios';

import Oruga from '@oruga-ui/oruga-next';
import '@oruga-ui/theme-bulma/dist/bulma.css';
import 'bulma/css/bulma.css';

document.title =
  location.hostname === 'localhost' ? 'My Tiny Inc (DEBUG)' : 'My Tiny Inc';

async function bootstrap() {
  const app = createApp(App);

  app.config.globalProperties.$api = api;

  const access = localStorage.getItem('access');

  if (access) {
    store.commit('SET_TOKEN', access);

    // Load current user after refresh
    await store.dispatch('fetchCurrentUser');

    // Restore license session
    try {
      await api.post('auth/login-license/');
      store.commit('SET_HAS_LICENSE_SESSION', true);
    } catch {
      store.commit('CLEAR_TOKENS');
    }
  }

  app
    .use(store)
    .use(router)
    .use(Oruga, {
      config: {
        iconPack: 'fas',
        autoImport: true,
      },
    })
    .mount('#app');
}

bootstrap();
